var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { myackAxiosInstance } from 'ziphy-web-shared/basic/api';
import { APP_REVISION, PUBLIC_URL } from 'ziphy-web-shared/basic/helpers';
import { BaseService } from '../../baseService';
export class _LEGACY_Notes extends BaseService {
    constructor(props) {
        super(props);
    }
    readSignature(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.fetchLoggedV3('patient_stories.get_notes_signature', params, options);
        });
    }
    listSignatures(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.fetchLoggedV3('patient_stories.get_notes_signatures', params, options);
        });
    }
    signNotes(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.fetchLoggedV3('patient_stories.sign_notes', params, options);
        });
    }
    /*
       Saving
       */
    saveAddendum(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.fetchLoggedV3('patient_stories.save_addendum', params, options);
        });
    }
    // /*
    //    Reading
    //    */
    readNotes(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.fetchLoggedV3('patient_stories.read_notes', params, options);
        });
    }
    readSignedNotes(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.fetchLoggedV3('patient_stories.read_signed_notes', params, options);
        });
    }
    loadConfig(params, options) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const urls = [
                `${PUBLIC_URL}/dist/notes/${params.practiceId}-${params.serviceId}.json?v=${APP_REVISION}`,
                `${PUBLIC_URL}/dist/notes/${params.practiceId}.json?v=${APP_REVISION}`,
            ];
            let url = `${PUBLIC_URL}/dist/notes/any.json?v=${APP_REVISION}`;
            const responses = yield Promise.allSettled(urls.map((url) => myackAxiosInstance.head(url)));
            for (let index in responses) {
                const response = responses[index];
                if (response.status === 'fulfilled' &&
                    ((_a = response === null || response === void 0 ? void 0 : response.value) === null || _a === void 0 ? void 0 : _a.status) === 200 &&
                    ((_c = (_b = response === null || response === void 0 ? void 0 : response.value) === null || _b === void 0 ? void 0 : _b.headers['content-type']) === null || _c === void 0 ? void 0 : _c.includes('application/json')) &&
                    urls[index]) {
                    url = urls[index];
                    break;
                }
            }
            const response = yield myackAxiosInstance.get(url);
            return response.data;
        });
    }
}
